import { ReaderTheme } from '@annunciate/core';
import { useReaderPreferences } from './useReaderPreferences';
import { useTheme } from '../useTheme';
export const useReaderColors = () => {
    const theme = useTheme();
    const readerPreferences = useReaderPreferences();
    let background;
    let backgroundInverted;
    switch (readerPreferences.theme) {
        case ReaderTheme.LIGHT:
            background = 'white';
            backgroundInverted = 'black';
            break;
        case ReaderTheme.DARK:
            background = 'black';
            backgroundInverted = 'white';
            break;
        case ReaderTheme.SEPIA:
            background = '#FAF4E8';
            backgroundInverted = 'black';
            break;
        default:
            background = theme.colors.backgroundPrimary;
            backgroundInverted = theme.colors.backgroundInverted;
    }
    return {
        background,
        backgroundInverted,
    };
};
//# sourceMappingURL=useReaderColors.js.map